import type { IdentityCardCrop } from '@/types';

const CLOUDINARY_IMAGE_UPLOAD = /^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.+)$/;

export function isCroppableImage(url: string | undefined): boolean {
  return Boolean(url && CLOUDINARY_IMAGE_UPLOAD.test(url));
}

/**
 * Preview-only mirror of the server's buildCardPhotoUrl
 * (server/src/modules/guide-identity/identity-card.utils.ts). The server
 * always recomputes the stored URL, so this only drives the live preview.
 */
export function previewCardPhotoUrl(sourceUrl: string, crop?: IdentityCardCrop): string {
  const match = sourceUrl.match(CLOUDINARY_IMAGE_UPLOAD);
  if (!match) return sourceUrl;
  const steps: string[] = [];
  if (crop) steps.push(`c_crop,x_${crop.x},y_${crop.y},w_${crop.width},h_${crop.height}`);
  steps.push('c_fill,g_auto,w_630,h_1020,q_auto');
  return `${match[1]}${steps.join('/')}/${match[2]}`;
}
